import { useContext } from 'react';
import ConfigurationContext from './ui-context';
import * as UIContextConstants from './ui-constants';

const useUIContext = () => {
	return useContext(ConfigurationContext);
};

export default useUIContext;
export { UIContextConstants };
